import { Backdrop, Button, Card, CardActions, CardContent, CardHeader, CircularProgress, Divider, FormControl, InputAdornment, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@material-ui/core';
import CropFreeIcon from '@material-ui/icons/CropFree';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { CustomTableCell } from 'src/components/CustomTableCell';
import GenericBulletinDialog from 'src/components/GenericBulletinDialog';
import MaterialDisplay from 'src/components/MaterialDisplay';
import AddressSearch from 'src/components/Selects/AddressSearch';
import { setAlert } from 'src/store/actions/alertActions';
import { getMaterial } from 'src/store/api/materialOperations';
import axios from "src/utils/axios";
import { CreateWareHouseAddress, getUser, GetWarehouseAddress } from 'src/utils/Common';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  container: {
    maxHeight: 650,
    minHeight: 650,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));



const defaultMaterial = {
  MaterialId: '',
  MaterialCode: '',
  MaterialDesc: ''
}

function RightPane({ data, setData, addMaterial, saveMaterials, setAlert }) {
  const [imageProps, setImageProps] = useState({ open: false, materialCode: null, materialDesc: '' });
  const [previous, setPrevious] = React.useState({});
  const [WarehouseAddress, setWarehouseAddress] = useState([]);
  const [bulletinProps, setBulletinProps] = useState({ open: false, materialCode: null });
  const SessionUser = getUser();
  const [pagination, setPagination] = useState({ page: 0, rowsPerPage: 10 });

  const [material, setMaterial] = useState(defaultMaterial);

  const [barcode, setBarcode] = useState('');

  const [barcodeLoading, setBarcodeLoading] = useState(false);
  const user = getUser();
  let warehouseData = GetWarehouseAddress(user.ServiceShopId);
  let warehouseAddress = [];
  if (warehouseData === null) {
    warehouseAddress = [];
  } else {
    warehouseAddress = warehouseData.map(w => { return { ...w, Group: "Diğer Adresler", Materials: w.Materials.split(',') } });
  }

  React.useEffect(() => {
    CreateWareHouseAddress(SessionUser.ServiceShopId);
    var DegerWarehouseAddress = [];
    DegerWarehouseAddress = GetWarehouseAddress(SessionUser.ServiceShopId);
    setWarehouseAddress(DegerWarehouseAddress);
  }, []);


  const handleChangeWarehouseAdress = (value, index) => {
    let old_rows = [...data];
    old_rows[index].WarehouseAddress = value?.Id || 0;
    setData(old_rows);
  }

  
  const handleChangeCount = (value, index) => {
    let old_rows = [...data];
    old_rows[index].Count = value || 0;
    setData(old_rows);
  }




  const handleAddMaterial = (material) => {
    addMaterial(material.MaterialId, material.MaterialCode, material.MaterialDesc);
    setMaterial(defaultMaterial);
  }

  const handleChangeMaterial = (material, index) => {
    let old_rows = [...data];
    old_rows[index].materialId = material.MaterialId;
    old_rows[index].materialCode = material.MaterialCode;
    old_rows[index].materialDesc = material.MaterialDesc;
    setData(old_rows);
  }

  const handleRemoveRow = (index) => {
    let old_rows = [...data];
    old_rows.splice(index, 1);
    setData(old_rows);
  }

  

  const handleBarcodeEnter = barcodeTxt => {
    if (barcodeTxt === null || barcodeTxt.length < 2)
      return
    setBarcodeLoading(true);
    getMaterial(barcodeTxt)
      .then(response => {
        setBarcodeLoading(false);
        if (response.data.length === 0) {
          setAlert(barcodeTxt + ' stok numaralı malzeme sistemde tanımlı değil!...');
          return;
        }
        handleAddMaterial(response.data[0]);
      }).catch(error => {
        console.error(error);
        setAlert('bir hata oluştu!..');
        setBarcodeLoading(false);
      });
  }

  const onChange = (e, row) => {
    if (!previous[row.materialCode]) {
      setPrevious(state => ({ ...state, [row.materialCode]: row }));
    }
    var value = e.target.value;
    const name = e.target.name;
    if (parseInt(value) < 0){
      value = 1;
    }

    const newRows = data.map(item => {
      if (
        item.materialCode === row.materialCode
      ) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setData(newRows);
  };

  const classes = useStyles();

  const search = "";
  const setAdres = (param, index, MALZEME_STOK_NO) => {
    axios.get(`/GetAdresMalzemeKullanilabilirAdet/${SessionUser.ServiceShopId}/${param.Id}/${MALZEME_STOK_NO}`)
      .then(response => {
        let old_rows = [...data];
        old_rows[index].WarehouseAddress = param?.Id || 0;
        old_rows[index].WarehouseAddressText = param?.Description || 0;
        old_rows[index].Malzemeleri = param?.Materials || 0;
        old_rows[index].ADRES_ADET = response.data;
        setData(old_rows);
      })
      .catch(error => {
        console.log(error);
      });
  }

  return (
    <Paper>
      <Card className={classes.container}>
        <CardHeader title={' Numaralı Fatura Detayı'}
          action={
            <Button
              variant="contained"
              className={classes.button}
              color="secondary"
              endIcon={<SendIcon></SendIcon>}
              onClick={() => { setBarcode(''); saveMaterials(); }}>
              Kesİn Gİrİş
           </Button>
          }
        ></CardHeader>
        <Backdrop className={classes.backdrop} open={barcodeLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Divider />
        <CardActions>
          <FormControl fullWidth>
            <TextField
              label="Barkod"
              value={barcode}
              onChange={event => setBarcode(event.target.value)}
              onKeyPress={event => event.key === 'Enter' && handleBarcodeEnter(event.target.value)}
              InputProps={{ endAdornment: <InputAdornment position="end"> <CropFreeIcon /></InputAdornment>, }}
            />
          </FormControl>
        </CardActions>
        <CardContent>
          <TableContainer style={{ maxHeight: 450, minHeight: 450, }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell padding='none' align="left">MalzemeKodu</TableCell>
                  <TableCell padding='none' align="left">Malzeme</TableCell>
                  <TableCell padding='none' align="center">DepoAdet</TableCell>
                  <TableCell padding='none' align="center">AdresAdet</TableCell>
                  <TableCell padding='none' align="center">AlınanAdet</TableCell>
                  <TableCell padding='none' align="center" width="200">Adres</TableCell>
                  <TableCell padding='none' align="center" >Resim</TableCell>
                  <TableCell padding='none' align="center" >Bülten</TableCell>
                  <TableCell padding='none' align="center" >Sil</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell padding='none' align="left">
                      {row.materialCode}
                    </TableCell>
                    <TableCell padding='none' align="left">
                      {row.materialDesc}
                    </TableCell>
                    <TableCell
                    padding='none'
                      align="center"
                      className={classes.tableCell}
                    >
                      {parseInt(row.DEPO_ADET) > 0 ? (
                        parseInt(row.DEPO_ADET, 10)
                      ) : (
                        <b style={{ color: 'red' }}>
                          {parseInt(row.DEPO_ADET, 10)}
                        </b>
                      )}
                    </TableCell>
                    <TableCell
                      align="center"
                      padding='none'
                      className={classes.tableCell}
                    >
                      {parseInt(row.ADRES_ADET) > 0 ? (
                        parseInt(row.ADRES_ADET, 10)
                      ) : (
                        <b style={{ color: 'red' }}>
                          {parseInt(row.ADRES_ADET, 10)}
                        </b>
                      )}
                    </TableCell>
                    <CustomTableCell
                      {...{ row, name: 'Count', onChange, Adet: parseInt(row.ADRES_ADET, 10) }}
                    />
                    <TableCell padding='none' align="left">
                      <AddressSearch
                        setAdres={setAdres}
                        value={{
                          Id: row.WarehouseAddress || '0',
                          Description: row.WarehouseAddressText || 'Adres Seçiniz!...',
                          Materials: row.Malzemeleri | ''
                        } || ''}
                        searchParam={search}
                        MaterialCode={row.materialCode}
                        ServicePaperNr={0}
                        index={index}
                        Adres={row.WarehouseAddress || 0}
                        RowSelected={1}
                        Tip={"Giris"}
                      />
                    </TableCell>
                    <TableCell padding='none' align="center">
                      <ImageSearchIcon
                        onClick={() => setImageProps({ open: true, materialCode: row.materialCode, materialDesc: row.materialDesc })}
                        color="primary" />
                    </TableCell>
                    <TableCell padding='none' align="center">
                      <FindInPageIcon
                        onClick={(event) => setBulletinProps({ open: true, materialCode: row.materialCode })}
                        color="primary" />
                    </TableCell>
                    <TableCell padding='none' align="center">
                      <DeleteForeverIcon
                        onClick={() => handleRemoveRow(index)}
                        color="error" />
                    </TableCell>
                  </TableRow>
                ))}

              </TableBody>
            </Table>
          </TableContainer>         
        </CardContent>
      </Card>
      <MaterialDisplay {...imageProps} setProps={setImageProps} />
      <GenericBulletinDialog {...bulletinProps} setProps={setBulletinProps} />
    </Paper>
  );
}

export default connect(
  state => state,
  { setAlert }
)(RightPane);
